//background-video-alt-img

    document.addEventListener("DOMContentLoaded", function() {
      if (!sessionStorage.getItem("firstLoadDone")) {
        sessionStorage.setItem("firstLoadDone", "true");

        window.scrollTo(0, 0);

        setTimeout(() => window.scrollTo(0, 0), 10);
      }
    });

    document.addEventListener("DOMContentLoaded", function() {
      document.querySelectorAll("video.section-video img").forEach(function(img) {
        if (!img.hasAttribute("alt")) {
          img.setAttribute("alt", "Video thumbnail image");
        }
      });
    });



    document.addEventListener("DOMContentLoaded", function () {
      const lazyVideos = document.querySelectorAll("video.section-video");

      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const video = entry.target;
            const source = video.querySelector("source");
            if (source && source.src) {
              video.play(); // load the video
            }
            observer.unobserve(video);
          }
        });
      }, { threshold: 0.25 }); // when 25% visible

      lazyVideos.forEach(video => {
        videoObserver.observe(video);
      });

    });


    document.addEventListener("DOMContentLoaded", function () {
      if(window.innerWidth <= 768) {
        document.querySelectorAll('.product-blocks__block--accordion-item .js-accordion-header').forEach((header)=>{
          header.setAttribute('aria-expanded', 'false');
        })
        document.querySelectorAll('.product-blocks__block--accordion-item .c-accordion__panel').forEach((header)=>{
          header.classList.remove('is-active'); 
        })
      }
    });


    document.addEventListener("DOMContentLoaded", function () {

      // Select ALL newsletter forms
      const forms = document.querySelectorAll('[action="/contact#section_newsletter_form"]');

      forms.forEach((form) => {
        const emailInput = form.querySelector('[name="contact[email]"]');
        if (!emailInput) return;

        form.addEventListener("submit", function (e) {
          const value = emailInput.value.trim();

          if (!value) {
            e.preventDefault()
            e.stopImmediatePropagation()
          };

          // Remove old error
          const oldError = form.querySelector(".note.note-error");
          const oldsuccess = form.querySelector(".note.note-success");
          if (oldError) oldError.remove();
          if (oldsuccess) oldsuccess.remove();

          if (!value) {
            // Create error block
            const errorDiv = document.createElement("div");
            errorDiv.classList.add("note", "note-error", "mb1");

            errorDiv.innerHTML = `
              <div class="inline-block v-center">
                  <svg class="icon--apollo-error mr3" height="12px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                    <g class="hover-fill" fill="var(--error-msg-dark)">
                      <path d="M9,13h2v2H9V13z M9,5h2v6H9V5z M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10c5.5,0,10-4.5,10-10S15.5,0,10,0z M10,18
                      c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S14.4,18,10,18z"></path>
                    </g>
                  </svg>
              </div>
              <p class="sm-caps inline-block v-center mb0">Email can't be blank.</p>
            `;

            // Insert at top of this form
            form.insertAdjacentElement("afterbegin", errorDiv);
          }
        });
      });

    });

 
document.addEventListener("DOMContentLoaded", function () {
  const lazyVideos = document.querySelectorAll(".product-gallery__product-video iframe");

  document.querySelector('#main-image-gallery')?.addEventListener('click', (e) => {

    const isExternalThumb = e.target.closest('.external_video-thumbnail');
    const isSlideBtn = e.target.closest('#main-slider .flickity-button');

    lazyVideos.forEach(video => {

      if (!video || video.tagName.toLowerCase() !== "iframe") return;

      let videoSrc = video.src;

      // Remove any existing mute=0 or mute=1 param
      videoSrc = videoSrc.replace(/([&?])mute=[01]/, '');

      const hasQuery = videoSrc.includes('?');
      const separator = hasQuery ? '&' : '?';
      if (isExternalThumb || isSlideBtn) {
        // CLICKED ON EXTERNAL THUMB → SET mute=1
        if (!videoSrc.includes('mute=0')) {
          video.src = `${videoSrc}${separator}mute=0`;
        }
      } else {
        // CLICKED ANYTHING ELSE → SET mute=0
        if (!videoSrc.includes('mute=1')) {
          video.src = `${videoSrc}${separator}mute=1`;
        }
      }

      // console.log(video.src);
    });

  });
});


//   function applyTabIndexToCards() {
//     const cards = document.querySelectorAll('.aca_ui_container [tabindex]');

//     if (cards.length === 0) {
//       requestAnimationFrame(applyTabIndexToCards);
//       return;
//     }

//     cards.forEach((el) => el.setAttribute('tabindex', '0'));
//   }
    
//   // Start
//   requestAnimationFrame(applyTabIndexToCards);


//   function checkPopup() {
//     const popup = document.querySelector('[aria-label="Alia popup"]');
//     if (popup) {
//       const imgs = popup.querySelectorAll('img');
//       imgs.forEach(img => {
//         img.setAttribute('width', img.naturalWidth);
//         img.setAttribute('height', img.naturalHeight);
//       });
//       return; // stop the loop
//     }
//     requestAnimationFrame(checkPopup);
//   }

//   requestAnimationFrame(checkPopup);


//   document.addEventListener('DOMContentLoaded', () => {
//   const videos = document.querySelectorAll('.template-product .js-video-external-wrapper[data-video]');
  
//   if ('IntersectionObserver' in window) {
//     const observer = new IntersectionObserver((entries, obs) => {
//       entries.forEach(entry => {
//         if (entry.isIntersecting) {
//           const wrapper = entry.target;
//           const videoHTML = wrapper.getAttribute('data-video');
//           wrapper.innerHTML = videoHTML; // inject iframe
//           wrapper.removeAttribute('data-video');
//           obs.unobserve(wrapper); // stop observing once loaded
//         }
//       });
//     }, {
//       rootMargin: '200px 0px', // preload slightly before visible
//       threshold: 0.1
//     });
    
//     videos.forEach(video => observer.observe(video));
//   } else {
//     // Fallback for old browsers — just load all
//     videos.forEach(video => {
//       video.innerHTML = video.getAttribute('data-video');
//       video.removeAttribute('data-video');
//     });
//   }
// });
